import clsx from "clsx";
import { motion, useInView } from "framer-motion";
import { useMemo, useRef } from "react";

import Dot from "../../../public/images/Dot";
import "./cardsApps.scss";

const ITEMS = [
  {
    title: "Team",
    text: "Our team offers a complete range of web & mobile application services.",
    theme: "blue",
  },
  {
    title: "Idea",
    text: "From just an idea to architecture",
    theme: "pink",
  },
  {
    title: "App",
    text: "An app becomes the one that reaches goals of our customers and wins the hearts of users.",
    theme: "orange",
  },
  {
    title: "Simple",
    text: "You can come to us at any stage of your project.",
    theme: "violet",
  },
];

export default function CardsApps() {
  const rootRef = useRef(null);

  const inView = useInView(rootRef, { amount: 0.35, once: true });

  const xRow = useMemo(() => [-600, -150, 270, 660], []);

  const containerVariants = useMemo(
    () => ({
      hidden: {},
      visible: {
        transition: {
          staggerChildren: 0.09,
          delayChildren: 1.6,
        },
      },
    }),
    [],
  );

  const stackRotate = useMemo(() => [-12, -5, 6, 12], []);
  const rowRotate = useMemo(() => [-6, 18, -12, 0], []);

  const cardVariants = useMemo(
    () => ({
      hidden: (idx) => ({
        opacity: 1,
        x: 0,
        y: 0,
        scale: 1,
        rotateZ: stackRotate[idx] ?? 0,
        zIndex: 10 - idx,
      }),

      visible: (idx) => ({
        opacity: 1,
        x: xRow[idx] ?? 0,
        y: 0,
        scale: 1,
        rotateZ: rowRotate[idx] ?? 0,
        zIndex: 1,
        transition: {
          duration: 0.7,
          ease: [0.2, 0.9, 0.2, 1],
        },
      }),
    }),
    [xRow, stackRotate, rowRotate],
  );

  return (
    <motion.div
      ref={rootRef}
      className="cards"
      initial="hidden"
      animate={inView ? "visible" : "hidden"}
      variants={containerVariants}
    >
      {ITEMS.map((item, idx) => (
        <motion.div
          key={item.title}
          className={clsx(
            "cards__card",
            `cards__card--${idx + 1}`,
            `cards__card--${item.theme}`,
          )}
          variants={cardVariants}
          custom={idx}
        >
          <div className="cards__card__content">
            <h3 className="cards__card__content__title">{item.title}</h3>
            <p className="cards__card__content__text">{item.text}</p>
          </div>

          <div className="cards__card__dot">
            <Dot />
          </div>
        </motion.div>
      ))}
    </motion.div>
  );
}
